import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CandidateDetailsSelectResolver } from './candidate-details-select.resolver';
import { CandidateDetailsModalComponent } from './containers/candidate-details-modal.container';

export const modalRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: ':id',
        component: CandidateDetailsModalComponent,
        resolve: [CandidateDetailsSelectResolver]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(modalRoutes)],
  exports: [RouterModule],
  providers: [CandidateDetailsSelectResolver]
})
export class CandidateDetailsRoutingModule {}
